import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ServiceTemplate from './pages/ServiceTemplate';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Landing Page - Special Layout */}
          <Route path="/lp" element={<LandingPage />} />
          
          {/* Main Site - With Header & Footer */}
          <Route path="/*" element={
            <>
              <Header />
              <div>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/services/:slug" element={<ServiceTemplate />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                </Routes>
              </div>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;
